module.exports = __webpack_public_path__ + "static/media/female_right_grey.e1d56ea4.png";